import {ThemeOptions, inputLabelClasses, Breakpoints} from '@mui/material';
import {CSSProperties} from 'react';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiInputLabel = ({inputfield}: Tokens, mediaQueries: Breakpoints): ThemeOptions['components'] => {
  const {desktop, mobile} = inputfield.adornments;

  return {
    MuiInputLabel: {
      defaultProps: {
        shrink: false
      },
      styleOverrides: {
        root: {},
        outlined: {
          pointerEvents: 'initial',
          transform: 'none'
        },
        formControl: {
          position: 'relative'
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          maxWidth: 'unset !important',
          color: desktop.label.font.color,
          fontSize: desktop.label.font.size,
          fontWeight: desktop.label.font.weight as CSSProperties['fontWeight'],
          lineHeight: desktop.label.font.lineHeight,
          marginBottom: desktop.label.margin.bottom,
          [mediaQueries.down('sm')]: {
            fontSize: mobile.label.font.size,
            fontWeight: mobile.label.font.weight as CSSProperties['fontWeight'],
            lineHeight: mobile.label.font.lineHeight
          },
          '& .labelInstructionText': {
            color: desktop.description.font.color,
            fontFamily: desktop.description.font.family,
            lineHeight: desktop.description.font.lineHeight,
            fontSize: desktop.description.font.size,
            fontWeight: desktop.description.font.weight as CSSProperties['fontWeight'],
            [mediaQueries.down('sm')]: {
              fontSize: mobile.label.font.size,
              fontWeight: mobile.label.font.weight as CSSProperties['fontWeight'],
              lineHeight: mobile.label.font.lineHeight
            }
          },
          '& .formTooltipIcon': {
            color: desktop.tooltip.color,
            height: desktop.tooltip.height,
            width: desktop.tooltip.width,
            marginLeft: 4
          },
          '& .tooltipLabel': {
            color: desktop.tooltip.color,
            marginLeft: 4
          },
          [`&.${inputLabelClasses.focused}`]: {
            color: desktop.label.font.color
          },
          [`&.${inputLabelClasses.disabled}`]: {
            color: desktop.label.disabled.font.color
          },
          [`&.${inputLabelClasses.error}`]: {
            color: desktop.label.error.font.color
          }
        },
        asterisk: {
          color: desktop.asterisk.color
        }
      }
    }
  };
};
